/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Reply_SubmitInputs */

const en_admin_tickets_reply_submit = /** @type {(inputs: Admin_Tickets_Reply_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Reply`)
};

/**
* | output |
* | --- |
* | "Send Reply" |
*
* @param {Admin_Tickets_Reply_SubmitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_reply_submit = /** @type {((inputs?: Admin_Tickets_Reply_SubmitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Reply_SubmitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_reply_submit(inputs)
});
export { admin_tickets_reply_submit as "admin.tickets.reply_submit" }